const hilfeContent = {
    german: {    
        titelContactForm: "Kontakt zum Awareness-Team",
        
    },
    english: {
        titelContactForm: "Contact the awareness team",
    }
}
export {hilfeContent}